/* KlarCar - rastreio de pedido */
(function () {
  function liga(raiz) {
    if (raiz.dataset.kcReady) return;
    raiz.dataset.kcReady = '1';
    var campo = raiz.querySelector('[data-kc-track-input]');
    var botao = raiz.querySelector('[data-kc-track-btn]');
    var aviso = raiz.querySelector('[data-kc-track-hint]');
    var base = raiz.dataset.base || 'https://t.17track.net/en#nums=';
    if (!campo || !botao) return;

    function limpo() {
      // codigo de rastreio nao tem espaco nem pontuacao
      return campo.value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    }
    function atualiza() {
      botao.disabled = limpo().length < 6;
      if (aviso) aviso.hidden = true;
    }
    function abre() {
      var c = limpo();
      if (c.length < 6) { if (aviso) aviso.hidden = false; return; }
      window.open(base + encodeURIComponent(c), '_blank', 'noopener');
    }
    campo.addEventListener('input', atualiza);
    campo.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); abre(); } });
    botao.addEventListener('click', abre);
    atualiza();
  }
  function varre() { document.querySelectorAll('[data-kc-track]').forEach(liga); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', varre);
  else varre();
  document.addEventListener('shopify:section:load', varre);
})();
